import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

const HotelsList = ({
    hotels,
    onSelect,
    selectedHotel,
}) => {
    const handleToggle = (hotelName) => {
        if (selectedHotel !== hotelName) {
            onSelect(hotelName)
        }
    }

    return (
        <ul className="trip-select-list">
            {hotels.map((hotel) => {
                const isSelected = selectedHotel === hotel

                return (
                    <li key={hotel.toLowerCase().replaceAll(' ', '-')}
                        className="trip-select-list__item"
                    >
                        <label className="trip-select-list__label">
                            <input
                                type="checkbox"
                                checked={isSelected}
                                onChange={() => handleToggle(hotel)}
                                className="trip-select-list__input"
                            />
                            <span></span>
                            {hotel}
                        </label>
                    </li>
                )
            })}
        </ul>
    )
}

HotelsList.propTypes = {
    hotels: PropTypes.arrayOf(PropTypes.string).isRequired,
    onSelect: PropTypes.func,
    selectedHotel: PropTypes.string || null,
}

const mapStateToProps = (state) => ({
    selectedHotel: state.apartmentReducer.hotel,
})

export default connect(mapStateToProps)(HotelsList)


